import styled from 'styled-components';
import { ml, my } from '@lendi-ui/spacing';
import { body, link } from '@lendi-ui/typography';

export const TagsWrapper = styled.p`
  ${body({ size: 'xs' })}
  ${my('md')}
`;

export const Alink = styled.a`
  ${link({ size: 'xs', color: 'primary.500' })}
  ${ml('xxxs')}
  font-weight: normal;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-decoration: none;
  :active {
    text-decoration: none;
  }
`;
